<template>
  <v-form ref="form">
    <v-row>
      <v-col>
        <v-text-field
          v-model="tav"
          label="Ter attentie van"
          autocomplete="name"
        />
      </v-col>

      <v-col>
        <v-text-field
          v-model="toLocation"
          label="Locatie en/of afdeling"
          autocomplete="organization"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="toStreet"
          label="Straat"
          autocomplete="street-address"
        />
      </v-col>

      <v-col>
        <v-text-field
          v-model="toHouseNumber"
          :rules="[rules.houseNumber]"
          label="Huisnummer"
          autocomplete="address-line2"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="toPostalCode"
          :rules="[rules.postCode]"
          label="Postcode"
          autocomplete="postal-code"
        />
      </v-col>

      <v-col>
        <v-text-field
          v-model="toCity"
          label="Stad"
          autocomplete="address-level2"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-select
          v-model="toCountry"
          :items="countries"
          item-text="country"
          item-value="abbr"
          label="Land"
          autocomplete="country"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: 'LocationAddressForm',
  props: {
    value: {
      type: Object,
      default: () => ({
        tav: null,
        toLocation: null,
        toStreet: null,
        toHouseNumber: null,
        toCity: null,
        toPostalCode: null,
        toCountry: 'NL',
      }),
    },
  },
  data() {
    return {
      rules: {
        postCode: (v) => !v || /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i.test(v) || 'Geen geldige postcode',
        houseNumber: (v) => !v || /^.{0,10}$/.test(v) || 'Maximaal aantal karakters of cijfers is 10',
      },
      countries: [
        { country: 'Nederland', abbr: 'NL' },
      ],
    };
  },
  computed: {
    tav: {
      get() { return this.value.tav; },
      set(v) { this.emitUpdate('tav', v); },
    },
    toLocation: {
      get() { return this.value.toLocation; },
      set(v) { this.emitUpdate('toLocation', v); },
    },
    toStreet: {
      get() { return this.value.toStreet; },
      set(v) { this.emitUpdate('toStreet', v); },
    },
    toHouseNumber: {
      get() { return this.value.toHouseNumber; },
      set(v) { this.emitUpdate('toHouseNumber', v); },
    },
    toCity: {
      get() { return this.value.toCity; },
      set(v) { this.emitUpdate('toCity', v); },
    },
    toPostalCode: {
      get() { return this.value.toPostalCode; },
      set(v) { this.emitUpdate('toPostalCode', v); },
    },
    toCountry: {
      get() { return this.value.toCountry; },
      set(v) { this.emitUpdate('toCountry', v); },
    },
  },
  methods: {
    emitUpdate(key, newValue) {
      this.$emit('input', { ...this.value, [key]: newValue });
    },
    validate() {
      return this.$refs.form.validate();
    },
  },
};
</script>
